import React from "react";
import cx from "classnames";
import { injectIntl } from "react-intl";
import withStyles from "isomorphic-style-loader/withStyles";
import Loader from "../../Common/Loader/Loader";
import defaultIcon from '/public/Icons/defaultImage.svg';
import s from "../SiteSettingsForm/SiteSettingsForm.css";

const CommonImageDisplay = ({ loader, imageSrc }) => {
  return (
    <div className="commonImageDisplayLoader">
      <Loader show={loader} type="page">
        <div
          className={cx(s.backgroundImg, !imageSrc && s.defaultIcon)}
          style={{
            backgroundImage: `url(${imageSrc || defaultIcon})`,
          }}
        />
      </Loader>
    </div>
  );
};

export default injectIntl(withStyles(s)(CommonImageDisplay));
